module.exports = __webpack_public_path__ + "img/mb-chrome.91ef4431.svg";